var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardHoliday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#FFEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 14.5V17M21.5 14.5C21.5 13.1193 22.6193 12 24 12C25.3807 12 26.5 13.1193 26.5 14.5C26.5 15.8807 25.3807 17 24 17M21.5 14.5C21.5 13.1193 20.3807 12 19 12C17.6193 12 16.5 13.1193 16.5 14.5C16.5 15.8807 17.6193 17 19 17M21.5 17H24M21.5 17H19M21.5 17V23M24 17H27.3002C28.4203 17 28.9796 17 29.4074 17.218C29.7837 17.4097 30.0905 17.7155 30.2822 18.0918C30.5 18.5192 30.5 19.079 30.5 20.1969V23M19 17H15.7002C14.5801 17 14.0196 17 13.5918 17.218C13.2155 17.4097 12.9097 17.7155 12.718 18.0918C12.5 18.5196 12.5 19.0801 12.5 20.2002V23M12.5 23V25.8002C12.5 26.9203 12.5 27.4801 12.718 27.9079C12.9097 28.2842 13.2155 28.5905 13.5918 28.7822C14.0192 29 14.579 29 15.6969 29H21.5M12.5 23H21.5M21.5 23V29M21.5 23H30.5M21.5 29H27.3031C28.421 29 28.98 29 29.4074 28.7822C29.7837 28.5905 30.0905 28.2842 30.2822 27.9079C30.5 27.4805 30.5 26.9215 30.5 25.8036V23",
    stroke: "#9F000A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHoliday);
export default __webpack_public_path__ + "static/media/dashboardHoliday.c08abe09488af193c02d502ac6698fb7.svg";
export { ForwardRef as ReactComponent };